import type { GameResponse } from '@warcarp/api-types'

/** Only public, joinable lobbies should contribute to the home banner. */
export function getPublicOpenGames(games: GameResponse[], viewerUserId?: string): GameResponse[] {
  return games.filter(
    (game) => game.isPublic && game.status === 'LOBBY' && game.players.length < game.maxPlayers &&
      game.viewerInvitationStatus !== 'pending' &&
      (!viewerUserId || (!game.players.some(player => player.userId === viewerUserId) &&
        !game.invitations.some(invite => invite.status === 'pending' && invite.user.id === viewerUserId))),
  )
}

/** Copy for the home screen's public games waiting for players banner. */
export function publicLobbySummary(count: number, hasMore: boolean) {
  const gameLabel = count === 1 ? 'game needs' : 'games need'
  return {
    label: `${count}${hasMore ? '+' : ''} ${gameLabel} players`,
    accessibilityLabel: `Join public games: ${hasMore ? 'at least ' : ''}${count} ${gameLabel} players`,
  }
}
